<app-notification-toast></app-notification-toast>

<router-outlet />

<!-- Shown by authGuard when a logged-out user opens a protected page -->
<app-confirmation-popup [isOpen]="loginPrompt.isOpen()" icon="lock" title="Login Required"
    message="To view" highlightedName="this content"
    messageSuffix="you need to be logged in first" confirmLabel="Log In" cancelLabel="Close"
    (confirmed)="goToLogin()" (cancelled)="loginPrompt.close()">
</app-confirmation-popup>

<!--
  Mounted once, here, at the app root — NOT inside app-dashboard-layout.
  Incoming/active call UI must be visible no matter which page the user is
  on (home, profile, events…), not only while they happen to have the
  chat screen open. Keep this as the single instance in the whole app;
  duplicating it elsewhere would double up its socket subscriptions.
-->
<app-call-overlay></app-call-overlay>

<!-- Admin "Quick Login" session indicator. Only shown when an admin opened
     the site as a managed user from the admin panel. -->
@if (quickLoginUser(); as qlUser) {
  <div class="fixed bottom-4 left-1/2 z-[9999] -translate-x-1/2 flex items-center gap-3 rounded-full bg-gray-900/90 px-4 py-2 text-sm text-white shadow-lg backdrop-blur">
    <span>Viewing as <strong>&#64;{{ qlUser }}</strong> (admin quick login)</span>
    <button type="button"
      class="rounded-full bg-white/15 px-3 py-1 text-xs font-medium hover:bg-white/25 disabled:opacity-50"
      [disabled]="leavingQuickLogin()"
      (click)="backToAdmin()">
      {{ leavingQuickLogin() ? 'Leaving…' : 'Back to admin panel' }}
    </button>
  </div>
}
